import { useEffect } from 'react';
import Project1Image from "@/assets/logo/logo-light.webp";

export default function Footer() {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  useEffect(() => {
    // Initialize Tawk.to chat widget
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/68d6be798b3ee61953e1bd44/1j63dg3ek';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    // Append script to document
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Cleanup function to prevent duplicate scripts
    return () => {
      // Remove the script when component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <footer className="bg-[#212026] dark:bg-gray-900 text-white transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img
                src={Project1Image}
                alt="Drafting By DMI"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-[#dbcfbf] dark:text-gray-300 mb-6 max-w-md">
              Professional engineering and drafting solutions specializing in AutoCAD, Revit, Dialux, and comprehensive technical drawings for architects and contractors.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-[#889d8f] dark:text-gray-400 hover:text-[#e18033] dark:hover:text-[#e18033] transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-linkedin-fill text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-[#dbcfbf] dark:text-gray-300 hover:text-white dark:hover:text-white transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-[#e18033]"></i>
                </div>
                <span className="text-[#dbcfbf] dark:text-gray-300">info@digitalmediainnovations.com</span>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line text-[#e18033]"></i>
                </div>
                <span className="text-[#dbcfbf] dark:text-gray-300">+1.303.873.1100</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#889d8f] dark:border-gray-700 mt-8 pt-8">
          <p className="text-xs text-[#889d8f]/80 dark:text-gray-500 leading-relaxed mb-6 max-w-5xl mx-auto text-center">
            <span className="font-semibold text-[#889d8f] dark:text-gray-400">Disclaimer of Liability:</span> All drafting and CAD services provided by DMI are for representational and coordination purposes only, based strictly on the drafting parameters supplied by the client. We do not provide architectural stamping, structural engineering, or municipal code verification. Final code compliance and municipal permitting remain the sole responsibility of the client's licensed architect or engineer of record. All material takeoffs are objective quantity surveys; clients are solely responsible for applying localized labor rates, waste factors, and finalizing bid pricing.
          </p>
          <p className="text-[#889d8f] dark:text-gray-400 text-center">
            © 2026 DMI Drafting services, a trade mark of iClass Automation , LLC
          </p>
        </div>
      </div>
    </footer>
  );
}